import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { createI18n } from '@pta/i18n';
import App from './App';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

const apiBase = (import.meta.env.VITE_API_BASE as string | undefined) ?? 'https://api.szmk-net.hu';
const { i18n } = createI18n({ app: 'fe', apiBase });

// FE témaszín: teal — vizuálisan eltér a FEA indigo-tól, így nehezebb összetéveszteni.
const theme = createTheme({
  primaryColor: 'teal',
  defaultRadius: 'md',
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <ModalsProvider>
          <Notifications />
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ModalsProvider>
      </MantineProvider>
    </I18nextProvider>
  </React.StrictMode>,
);
